import { Box, Button, Typography, styled } from "@mui/material";
import React from "react";
import Testimonial from "./Testimonial";
import { certificates } from "../constants/certificates";

const About = () => {
  const handleContactClick = () => {
    const recipient = "mlikbk@hotmail.com";

    const mailtoLink = `mailto:${recipient}?`;
    window.location.href = mailtoLink;
  };

  const CustomBox = styled(Box)(({ theme }) => ({
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    gap: "1rem",

    [theme.breakpoints.down("md")]: {
      flexDirection: "column",
      alignItems: "center",
    },
  }));

  const CustomTitleBox = styled(Box)(({ theme }) => ({
    width: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-around",
    [theme.breakpoints.down("md")]: {
      flexDirection: "column",
      alignItems: "center",
      gap: "2rem",
    },
  }));

  const CustomButton = styled(Button)(({ theme }) => ({
    border: "3px solid #B3565B",
    borderRadius: "25px",
    color: "white",
    width: "15%",
    display: "block",
    "&:hover": {
      border: "3px solid #B3565B",
      backgroundColor: "#B3565B",
    },
    [theme.breakpoints.down("md")]: {
      width: "50%",
    },
    [theme.breakpoints.down("sm")]: {
      width: "75%",
      padding: "16px",
    },
  }));

  return (
    <Box sx={{ maxWidth: "1300px", mt: 10, mb: 6, padding: 3, mx: "auto" }}>
      <CustomTitleBox
        sx={{
          width: "100%",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-around",
        }}
      >
        <Typography
          variant="h4"
          style={{
            color: "white",
            textAlign: "center",
            fontFamily: "'Arvo', serif;'",
          }}
        >
          Certifikat
        </Typography>
        <div
          style={{
            height: "5px",
            backgroundColor: "#B3565B",
            width: "50%",
            border: 0,
            borderRadius: "25px",
          }}
        ></div>
      </CustomTitleBox>

      <CustomBox sx={{ mt: 7, mb: 10 }}>
        {certificates.map((certificate) => (
          <Testimonial
            key={certificate.id}
            title={certificate.title}
            skills={certificate.skills}
            platform={certificate.platform}
            image={certificate.image}
            date={certificate.date}
            credential={certificate.credential}
          />
        ))}
      </CustomBox>

      <Box id="about">
        <div
          style={{
            height: "5px",
            backgroundColor: "#B3565B",
            width: "80%",
            marginLeft: "auto",
            marginRight: "auto",
            border: 0,
            borderRadius: "25px",
          }}
        ></div>

        <Typography
          variant="h4"
          sx={{
            color: "white",
            mt: 10,
            textAlign: "center",
            fontFamily: "'Arvo', serif;",
          }}
        >
          Om mig
        </Typography>
        <Typography
          variant="body1"
          sx={{ color: "white", mt: 10, textAlign: "center" }}
        >


          Jag är 31 år gammal och bor i Malmö med min snart 4 år gamla hund
          Shira. Programmering är något jag trillade in på för snart fem år
          sedan då vi hade en kurs i det på mitt dåvarande ingenjörsprogram. Jag
          tyckte det var så pass roligt att jag till slut bestämde mig för att
          avbryta ingenjörsstudierna och fortsätta med programmeringen på egen
          hand. Sedan dess har jag genom olika onlinekurser, kodträningssidor
          och mycket eget kodande lärt mig att programmera och bygga webbsidor.
        </Typography>
        <Typography
          variant="body1"
          sx={{ color: "white", mt: 3, textAlign: "center" }}
        >
          Det som driver mig speciellt är det kreativa och problemlösande i det.
          Jag har fastnat många gånger och känt att jag inte kommer vidare med
          ett problem, då är det bara att backa tillbaka till start och testa
          sig fram på en helt annan lösningsväg. Tålamodet sätts på prov, den
          kreativa delen av hjärnan får jobba och det lönar sig att ha bra
          grundförståelse för språket och programmen som man arbetar i. När man
          kommer till en viss nivå tycks det mest vara fantasin som sätter gräns
          för vad som är möjligt att skapa - en stor drivkraft i sig. Där har jag insett sedan jag kom in i hela
          programeringsvärlden att det finns allt för många bra iéer där ute
          som inte utvecklats till välfungerande webbappar ännu.
        </Typography>
        <Typography
          variant="body1"
          sx={{ color: "white", mb: 10, mt: 3, textAlign: "center" }}
        >
          Jag har arbetat allra mest med frontend, men har även hunnit sitta en del med databaser och API-utveckling. Jag är öppen för både frontend- och
          fullstackpositioner.
        </Typography>
        <CustomButton
          onClick={handleContactClick}
          variant="outlined"
          sx={{
            mx: "auto",
            mt: 3,
            mb: 8,
          }}
        >
          Ta kontakt
        </CustomButton>
      </Box>
    </Box>
  );
};

export default About;
